import React from 'react';
import NewCommitPopup from './NewCommitPopup';
import { LAST_180_DAYS } from '../../DateInput/constants';
import DateInputProvider from '../../../contextProviders/DateInputProvider';

const NewCommitPopupContainer = () => {
  return (
    <DateInputProvider initialRelativeDateRange={LAST_180_DAYS}>
      <NewCommitPopup />
    </DateInputProvider>
  );
};

export default NewCommitPopupContainer;
